import { useState, useEffect, useCallback } from 'react';
import Hero from './components/hero';
import Products from './components/products';
import Api from '../../services';
import { Product } from '../../types/retail-product';
import useLocaleRefresh from '../../hooks/use-locale-refresh';

export default function Home() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Api.retailProducts.getRetailProducts();
      setProducts(response.data);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  useLocaleRefresh(fetchProducts);

  return (
    <>
      <Hero />
      <Products data={products} loading={loading} />
    </>
  );
}
